module.exports = __webpack_public_path__ + "static/media/sm.eae16df8.png";